/**
 * @name EMAM.Module.js
 *
 * @author Anchor Group
 *
 * @since last updated date 2024-02-06
 *
 * @file
 */

define("EMAM.Module", ["MyAccountMenu", "Utils", "underscore"], function (
    MyAccountMenuModule,
    Utils,
    _
) {
    "use strict";

    return {
        load: function (container, user_role) {
            var MyAccountMenu = container.getComponent("MyAccountMenu");

            var Module;
            if (MyAccountMenuModule.MyAccountMenu) {
                Module = MyAccountMenuModule.MyAccountMenu.getInstance();
            } else {
                Module = MyAccountMenuModule.getInstance();
            }

            //remove all menu tabs and subtabs, then conditionally add them back
            if (Module) {
                Module.removeEntry("home");
                Module.removeEntry("orders");
                Module.removeEntry("productlists");
                Module.removeEntry("billing");
                Module.removeEntry("settings");
                Module.removeEntry("cases");
                Module.removeSubEntry("purchases");
                Module.removeSubEntry("returns");
                Module.removeSubEntry("reorderitems");
                Module.removeSubEntry("quotes");
                Module.removeSubEntry("balance");
                Module.removeSubEntry("invoices");
                Module.removeSubEntry("transactionhistory");
                Module.removeSubEntry("printstatement");
                Module.removeSubEntry("profileinformation");
                Module.removeSubEntry("emailpreferences");
                Module.removeSubEntry("addressbook");
                Module.removeSubEntry("paymentmethods");
                Module.removeSubEntry("updateyourpassword");
                Module.removeSubEntry("cases_all");
                Module.removeSubEntry("newcase");
            }

            /**
             * Used to hide or display my account tabs by logged in user's role.
             * @param {string} tabId - The tab id of may account menu.
             * @param {string} groupid - The id of tab group of my account menu.
             * @returns {boolean} hidetabs - hide or add menu depends on it's value.
             */
            function hideTabsByRole(tabId, groupid) {
                var hideTab = false,
                    config =
                        (container.Configuration && container.Configuration.hideMyaccountTabs) ||
                        [],
                    tabsToHide = _.where(config, { role: Number(user_role), showOrHide: "Hide" }),
                    tabsToShow = _.where(config, { role: Number(user_role), showOrHide: "Show" }),
                    tabIds = _.pluck(tabsToHide || [], "tabs"),
                    tabIdsToShow = _.pluck(tabsToShow || [], "tabs"),
                    tabIdMatched = tabIds.indexOf(tabId) != -1,
                    groupIdMatched = tabIds.indexOf(groupid) != -1,
                    allTabsToHide = tabIds.indexOf("All") != -1;

                if (
                    tabIdsToShow.length &&
                    (tabIdsToShow.indexOf(tabId) != -1 || tabIdsToShow.indexOf(groupid) != -1)
                ) {
                    return false;
                }

                if (tabIdMatched || groupIdMatched || allTabsToHide) {
                    hideTab = true;
                }

                return hideTab;
            }

            /**
             * Creates a menu tab on the My Account Page or submenu tab on the My Account page
             * @param {String} name menu name
             * @param {String} id menu id
             * @param {Integer} index menu index
             * @param {String} url menu url
             * @param {Array} permissions array of permission objects
             * @param {String} pOperator permissions operator
             * @param {String} groupid parent menu id
             */
            function add_MyAccountMenu(name, id, index, url, permissions, pOperator, groupid) {
                var hideTab = hideTabsByRole(id, groupid);

                if (hideTab) {
                    return;
                }

                let newMenu = {};
                id ? (newMenu.id = id) : null;
                name ? (newMenu.name = name) : null;
                url ? (newMenu.url = url) : null;
                index ? (newMenu.index = index) : null;
                permissions ? (newMenu.permission = permissions) : null;
                pOperator ? (newMenu.permissionoperator = pOperator) : null;
                if (!!groupid) {
                    newMenu.groupid = groupid;
                    MyAccountMenu.addGroupEntry(newMenu);
                } else {
                    MyAccountMenu.addGroup(newMenu);
                }
            }

            /**
             * Creates an array of object permissions, if any parameter is set to
             * true it is included
             * @param {Boolean} *All params are booleans
             * @returns {Array} array of permissions objects
             */
            function add_permissions(
                tranSalesOrd,
                tranEstimate,
                tranRtnAuth,
                tranFind,
                tranCustInvc,
                tranCustRec,
                tranCustPymt,
                tranCustDep,
                tranDepAppl,
                tranStatement,
                listCase,
                tranCustCred
            ) {
                let permission = [];
                tranSalesOrd &&
                    permission.push({ group: "transactions", id: "tranSalesOrd", level: "1" });
                tranEstimate &&
                    permission.push({ group: "transactions", id: "tranEstimate", level: "1" });
                tranRtnAuth &&
                    permission.push({ group: "transactions", id: "tranRtnAuth", level: "1" });
                tranFind && permission.push({ group: "transactions", id: "tranFind", level: "1" });
                tranCustInvc &&
                    permission.push({ group: "transactions", id: "tranCustInvc", level: "1" });
                tranCustRec &&
                    permission.push({ group: "transactions", id: "tranCustRec", level: "1" });
                tranCustPymt &&
                    permission.push({ group: "transactions", id: "tranCustPymt", level: "1" });
                tranCustDep &&
                    permission.push({ group: "transactions", id: "tranCustDep", level: "1" });
                tranDepAppl &&
                    permission.push({ group: "transactions", id: "tranDepAppl", level: "1" });
                tranStatement &&
                    permission.push({ group: "transactions", id: "tranStatement", level: "1" });
                listCase && permission.push({ group: "lists", id: "listCase", level: "2" });
                tranCustCred &&
                    permission.push({ group: "transactions", id: "tranCustCred", level: "1" });

                return permission;
            }

            if (MyAccountMenu) {
                if (container.Configuration.overviewShow == true) {
                    add_MyAccountMenu(
                        container.Configuration.overviewTitle,
                        "home",
                        0,
                        "/overview",
                        false,
                        false,
                        false
                    );
                }
                if (container.Configuration.ordersShow == true) {
                    let orderPermissions = add_permissions(
                        true,
                        true,
                        true,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false
                    );
                    add_MyAccountMenu(
                        container.Configuration.ordersTitle,
                        "orders",
                        2,
                        "",
                        orderPermissions,
                        "OR",
                        false
                    );

                    if (container.Configuration.purchasesShow == true) {
                        let purchasePermissions = add_permissions(
                            true,
                            false,
                            false,
                            true,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false
                        );
                        add_MyAccountMenu(
                            container.Configuration.purchasesTitle,
                            "purchases",
                            1,
                            "/purchases",
                            purchasePermissions,
                            "OR",
                            "orders"
                        );
                    }
                    if (container.Configuration.returnsShow == true) {
                        let returnsPermissions = add_permissions(
                            false,
                            false,
                            true,
                            true,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false
                        );
                        add_MyAccountMenu(
                            container.Configuration.returnsTitle,
                            "returns",
                            2,
                            "/returns",
                            returnsPermissions,
                            "OR",
                            "orders"
                        );
                    }
                    if (container.Configuration.reorderitemsShow == true) {
                        let reorderPermissions = add_permissions(
                            true,
                            false,
                            false,
                            true,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false
                        );
                        add_MyAccountMenu(
                            container.Configuration.reorderitemsTitle,
                            "reorderitems",
                            4,
                            "/reorderItems",
                            reorderPermissions,
                            "OR",
                            "orders"
                        );
                    }
                    if (container.Configuration.quotesShow == true) {
                        let quotesPermissions = add_permissions(
                            false,
                            true,
                            false,
                            true,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false
                        );
                        add_MyAccountMenu(
                            container.Configuration.quotesTitle,
                            "quotes",
                            5,
                            "/quotes",
                            quotesPermissions,
                            "OR",
                            "orders"
                        );
                    }
                }
                if (container.Configuration.billingShow == true) {
                    add_MyAccountMenu(
                        container.Configuration.billingTitle,
                        "billing",
                        3,
                        "",
                        false,
                        false,
                        false
                    );
                    if (container.Configuration.balanceShow == true) {
                        add_MyAccountMenu(
                            container.Configuration.balanceTitle,
                            "balance",
                            1,
                            "/balance",
                            false,
                            false,
                            "billing"
                        );
                    }
                    if (container.Configuration.invoicesShow == true) {
                        let invoicesPermissions = add_permissions(
                            false,
                            false,
                            false,
                            false,
                            true,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false
                        );
                        add_MyAccountMenu(
                            container.Configuration.invoicesTitle,
                            "invoices",
                            2,
                            "/invoices",
                            invoicesPermissions,
                            "OR",
                            "billing"
                        );
                    }
                    if (container.Configuration.transactionhistoryShow == true) {
                        let tHistoryPermissions = add_permissions(
                            false,
                            false,
                            false,
                            false,
                            true,
                            false,
                            true,
                            true,
                            true,
                            false,
                            false,
                            true
                        );
                        add_MyAccountMenu(
                            container.Configuration.transactionhistoryTitle,
                            "transactionhistory",
                            3,
                            "/transactionhistory",
                            tHistoryPermissions,
                            "OR",
                            "billing"
                        );
                    }
                    if (container.Configuration.printstatementShow == true) {
                        let printPermissions = add_permissions(
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            false,
                            true,
                            false,
                            false
                        );
                        add_MyAccountMenu(
                            container.Configuration.printstatementTitle,
                            "printstatement",
                            4,
                            "/printstatement",
                            printPermissions,
                            "OR",
                            "billing"
                        );
                    }
                }
                if (container.Configuration.settingsShow == true) {
                    add_MyAccountMenu(
                        container.Configuration.settingsTitle,
                        "settings",
                        5,
                        "",
                        false,
                        false,
                        false
                    );
                    if (container.Configuration.profileinformationShow == true) {
                        add_MyAccountMenu(
                            container.Configuration.profileinformationTitle,
                            "profileinformation",
                            1,
                            "/profileinformation",
                            false,
                            false,
                            "settings"
                        );
                    }
                    if (container.Configuration.emailpreferencesShow == true) {
                        add_MyAccountMenu(
                            container.Configuration.emailpreferencesTitle,
                            "emailpreferences",
                            2,
                            "/emailpreferences",
                            false,
                            false,
                            "settings"
                        );
                    }
                    if (container.Configuration.addressbookShow == true) {
                        add_MyAccountMenu(
                            container.Configuration.addressbookTitle,
                            "addressbook",
                            3,
                            "/addressbook",
                            false,
                            false,
                            "settings"
                        );
                    }
                    if (container.Configuration.paymentmethodsShow == true) {
                        add_MyAccountMenu(
                            container.Configuration.paymentmethodsTitle,
                            "paymentmethods",
                            4,
                            "/paymentmethods",
                            false,
                            false,
                            "settings"
                        );
                    }
                    if (container.Configuration.updateyourpasswordShow == true) {
                        add_MyAccountMenu(
                            container.Configuration.updateyourpasswordTitle,
                            "updateyourpassword",
                            5,
                            "/updateyourpassword",
                            false,
                            false,
                            "settings"
                        );
                    }
                }
                if (container.Configuration.casesShow == true) {
                    let casesPermissions = add_permissions(
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        true,
                        false
                    );
                    add_MyAccountMenu(
                        container.Configuration.casesTitle,
                        "cases",
                        6,
                        "",
                        casesPermissions,
                        "OR",
                        false
                    );
                    if (container.Configuration.casesallShow == true) {
                        add_MyAccountMenu(
                            container.Configuration.casesallTitle,
                            "cases_all",
                            1,
                            "/cases",
                            false,
                            false,
                            "cases"
                        );
                    }
                    if (container.Configuration.newcaseShow == true) {
                        add_MyAccountMenu(
                            container.Configuration.newcaseTitle,
                            "newcase",
                            2,
                            "/newcase",
                            false,
                            false,
                            "cases"
                        );
                    }
                }
                if (container.Configuration.productlistsShow == true) {
                    add_MyAccountMenu(
                        container.Configuration.productlistsTitle,
                        "productlists",
                        2,
                        "",
                        false,
                        false,
                        false
                    );
                }

                /**
                 * Custom tabs will be added unless role matched to hide tabs.
                 */
                // add_MyAccountMenu('Service Request', 'service_request', 10, '/serviceRequest', false, false, 'settings');
                // add_MyAccountMenu('Shipping Document Search', 'shipping_document_search', 10, '/searchfiles', false, false, false);
            }

            function setTitles(accountView, name, title) {
                if (!!accountView.__esModule) accountView = accountView[name];
                accountView.prototype.getContext = _.wrap(
                    accountView.prototype.getContext,
                    function (fn) {
                        var context = fn.apply(this, _.toArray(arguments).slice(1));
                        this.title = Utils.translate(title);

                        return context;
                    }
                );

                return;
            }

            if (SC.CONFIGURATION.currentTouchpoint == "customercenter") {
                const config = container.Configuration;

                setTitles(require("Overview.Home.View"), "OverviewHomeView", config.overviewTitle);

                setTitles(
                    require("OrderHistory.List.View"),
                    "OrderHistoryListView",
                    config.purchasesTitle
                );
                setTitles(
                    require("ReturnAuthorization.List.View"),
                    "ReturnAuthorizationListView",
                    config.returnsTitle
                );
                setTitles(
                    require("ReorderItems.List.View"),
                    "ReorderItemsListView",
                    config.reorderitemsTitle
                );
                setTitles(require("Quote.List.View"), "QuoteListView", config.quotesTitle);

                setTitles(
                    require("ProductList.Lists.View"),
                    "ProductListListsView",
                    config.productlistsTitle
                );
                setTitles(
                    require("ProductList.Edit.View"),
                    "ProductListEditView",
                    config.newcaseTitle
                );
                setTitles(
                    require("ProductList.ListDetails.View"),
                    "ProductListListDetailsView",
                    config.casesTitle
                );
                //setTitles(require('ProductList.Lists.View'), 'ProductListListsView', config.casesallTitle); //Redundant code, update if specific view is found

                //setTitles(require('Balance.View'), 'BalanceView', config.billingTitle); //Redundant code, update if specific view is found
                setTitles(require("Balance.View"), "BalanceView", config.balanceTitle);
                setTitles(
                    require("Invoice.OpenList.View"),
                    "InvoiceOpenListView",
                    config.invoicesTitle
                );
                setTitles(
                    require("TransactionHistory.List.View"),
                    "TransactionHistoryListView",
                    config.transactionhistoryTitle
                );
                setTitles(
                    require("PrintStatement.View"),
                    "PrintStatementView",
                    config.printstatementTitle
                );

                //setTitles(require('Profile.Information.View'), 'ProfileInformationView', config.settingsTitle); //Redundant code, update if specific view is found
                setTitles(
                    require("Profile.Information.View"),
                    "ProfileInformationView",
                    config.profileinformationTitle
                );
                setTitles(
                    require("Profile.EmailPreferences.View"),
                    "ProfileEmailPreferencesView",
                    config.emailpreferencesTitle
                );
                setTitles(require("Address.Edit.View"), "AddressEditView", config.addressbookTitle);
                setTitles(
                    require("PaymentInstrument.CreditCard.Edit.View"),
                    "PaymentInstrumentCreditCardEditView",
                    config.paymentmethodsTitle
                );
                setTitles(
                    require("Profile.UpdatePassword.View"),
                    "ProfileUpdatePasswordView",
                    config.updateyourpasswordTitle
                );
            }
        },
    };
});
